module.exports = __webpack_public_path__ + "static/media/profile_picture_3.3b546183.jpg";